import {ThunkDispatch} from "@reduxjs/toolkit";
import {connect, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import {roomDesignActions} from '../reducers/roomDesign'
import {selectCanCreateRoomDesign, selectCanConfirmReloadRoomDesign, selectCanRegenAfterImages, selectBeforeImageData} from '../selectors'
import {MaxRegenCount} from '../constants'
import {GenerateAfterPhotoIcon, ReloadRoomDesignIcon, LoadingIcon} from './SVGIcons'

function mapStateToProps(state: any) {
  const canCreateRoomDesign = selectCanCreateRoomDesign(state)
  const canConfirmReloadRoomDesign = selectCanConfirmReloadRoomDesign(state)
  const canRegenAfterImages = selectCanRegenAfterImages(state)
  const selectedBeforeImageData = selectBeforeImageData(state)
  const { isLoading, beforeImages } = state.roomDesign
  const hasProcessedImage = beforeImages.find((image: any) => image.id || image.isGeneratedFail)
  return {
    ...state.roomDesign,
    canCreateRoomDesign,
    canConfirmReloadRoomDesign,
    canRegenAfterImages,
    selectedBeforeImageData,
    hasProcessedImage,
    isLoading
  }
}

const RoomDesignEditActionButtons = (props: any) => {
  const {
    beforeImages,
    canCreateRoomDesign,
    canConfirmReloadRoomDesign,
    canRegenAfterImages,
    selectedBeforeImageData,
    hasProcessedImage,
    isLoading,
  } = props
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const navigate = useNavigate()
  const {id, isGeneratedFail} = selectedBeforeImageData ? selectedBeforeImageData : {}
  const confirmCreateRoomDesign = () => {
    if (!canCreateRoomDesign) return

    dispatch(roomDesignActions.setIsConfirmPopupShow(true))
  }

  const confirmRegenAfterImages = () => {
    if (!canRegenAfterImages) return

    dispatch(roomDesignActions.setIsRegenPopupShow(true))
  }

  const confirmClearAll = () => {
    if (!canConfirmReloadRoomDesign) return

    dispatch(roomDesignActions.setIsClearAllPopupShow(true))
  }

  return (
    <div className="grid grid-cols-9 gap-4 mt-3">
      <div className="col-span-4 col-start-2 space-y-2">
        <button type="button" onClick={confirmCreateRoomDesign} disabled={!(canCreateRoomDesign && !isGeneratedFail)}
          className={canCreateRoomDesign && !isGeneratedFail
            ? "px-5 py-2.5 flex items-center gap-1 rounded-full mx-auto text-sm text-white hover:text-white submit-btn hover:submit-btn"
            : "px-5 py-2.5 flex items-center gap-1 rounded-full mx-auto text-sm text-gray-900 bg-gray-400 disabled:opacity-75"}>
          <GenerateAfterPhotoIcon />
          AIホームステージング生成
          <span className="inline-flex items-center justify-center w-4 h-4 ms-2 text-xs font-semibold text-blue-800 submit-subtext rounded-full">
            {beforeImages.length}
          </span>
        </button>
      </div>
      {hasProcessedImage && (
        <div className="col-span-4 space-x-2 flex justify-center">
          {!id && (
            <button type="button" onClick={confirmCreateRoomDesign} disabled={!canCreateRoomDesign || isLoading}
              className={canCreateRoomDesign && !isLoading
                ? "px-5 py-2.5 flex items-center gap-1 rounded-full text-sm text-white justify-center submit-btn-2nd hover:bg-gray-100 w-full max-w-64"
                : "px-5 py-2.5 flex items-center gap-1 rounded-full text-sm text-white justify-center text-gray-900 bg-gray-400 disabled:opacity-75 w-full max-w-64"
              }>
              <ReloadRoomDesignIcon />
              再実行
              {isLoading && <LoadingIcon className="w-4 h-4 ml-1" />}
            </button>
          )}
          {id && (
            <button type="button" onClick={confirmRegenAfterImages} disabled={!canRegenAfterImages || isLoading}
              className={canRegenAfterImages && !isLoading
                ? "px-5 py-2.5 flex items-center gap-1 rounded-full text-sm justify-center submit-btn-2nd hover:bg-gray-100 w-full max-w-64"
                : "px-5 py-2.5 flex items-center gap-1 rounded-full text-sm text-white justify-center text-gray-900 bg-gray-400 disabled:opacity-75 w-full max-w-64"
              }>
              <ReloadRoomDesignIcon />
              {selectedBeforeImageData.maxRegenCount == MaxRegenCount ? "再実行" : `再実行（残り${selectedBeforeImageData.maxRegenCount}回）`}
              {isLoading && <LoadingIcon className="w-4 h-4 ml-1" />}
            </button>
          )}
          <button type="button" onClick={confirmClearAll} disabled={!canConfirmReloadRoomDesign || isLoading}
            className={canConfirmReloadRoomDesign && !isLoading
              ? "px-5 py-2.5 flex items-center gap-1 rounded-full text-sm justify-center bg-white text-gray-700 border border-gray-400 hover:bg-gray-50 w-full max-w-64"
              : "px-5 py-2.5 flex items-center gap-1 rounded-full text-sm justify-center text-gray-900 bg-gray-400 disabled:opacity-75 w-full max-w-64"
            }>
            別画像の加工を行う
          </button>
        </div>
      )}
    </div>
  );
};

export default connect(mapStateToProps)(RoomDesignEditActionButtons)